// <s-hem-input>: optional custom hem length on trouser pages.
// The value is sent as a line item property. The field is disabled (so not submitted) unless
// the shopper ticks the checkbox. State survives variant changes, which re-render the product form partial.
const memory = new Map();

class HemInput extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('[data-hem-toggle]');
    this.field = this.querySelector('[data-hem-field]');
    this.input = this.querySelector('[data-hem-value]');
    if (!this.toggle || !this.input) return;
    const key = this.dataset.productId;
    const saved = memory.get(key);
    if (saved) {
      this.toggle.checked = saved.on;
      this.input.value = saved.value;
    }
    const update = () => {
      const on = this.toggle.checked;
      this.field.hidden = !on;
      this.input.disabled = !on;
      this.input.required = on;
      memory.set(key, { on, value: this.input.value });
    };
    this.toggle.addEventListener('change', () => {
      update();
      if (this.toggle.checked) this.input.focus();
    });
    this.input.addEventListener('input', update);
    update();
  }
}

if (!customElements.get('s-hem-input')) customElements.define('s-hem-input', HemInput);
